import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import UpgradeModal from './UpgradeModal';

/**
 * Wraps any route/component that requires a paid plan.
 * If the user doesn't have access, renders the UpgradeModal instead of the content.
 *
 * Usage:
 *   <PlanGate feature="trades">
 *     <TradesPage />
 *   </PlanGate>
 */
const PlanGate = ({ feature, children }) => {
  const { isAuthenticated, canAccess } = useAuth();
  const [modalOpen, setModalOpen] = useState(true);

  if (!isAuthenticated) return children; // ProtectedRoute handles auth redirect

  if (canAccess(feature)) return children;

  return (
    <>
      {/* Blurred placeholder so the layout isn't empty */}
      <div style={{ filter: 'blur(4px)', pointerEvents: 'none', userSelect: 'none', opacity: 0.3 }}>
        {children}
      </div>
      {modalOpen && <UpgradeModal onClose={() => setModalOpen(false)} />}
    </>
  );
};

export default PlanGate;
